import router from '@/router/router'
import localforage from 'localforage'
import _ from 'lodash'

/**
 * 按用户按页面写入缓存
 * @param {string} path 访问路径 { a: { b: c } } 'a.b'
 * @param {any} data 写入数据
 */
export async function setUserDataForPage (path, data) {
  const userId = window.sessionStorage.getItem('user_id')
  const upath = router.app.$route.path
  if (userId && upath !== '/login') {
    const key = 'user-' + userId
    const tmp = await localforage.getItem(key) || {}
    if (data === undefined) {
      // 删除属性
      _.unset(tmp, `page.${upath}.${path}`)
    } else {
      // 设置属性
      _.set(tmp, `page.${upath}.${path}`, data)
    }
    // 存储修改后的对象
    await localforage.setItem(key, tmp)
  }
}

export async function getUserDataForPage (path, defaultValue = null) {
  const userId = window.sessionStorage.getItem('user_id')
  if (userId) {
    const key = 'user-' + userId
    const tmp = await localforage.getItem(key) || {}
    const upath = router.app.$route.path
    const result = _.get(tmp, `page.${upath}.${path}`, defaultValue)
    return result
  }
  return defaultValue
}

/**
 * 按用户写入数据
 * @param {string} path 访问路径 { a: { b: c } } 'a.b'
 * @param {any} data 写入数据
 */
export async function setUserData (path, data) {
  const userId = window.sessionStorage.getItem('user_id')
  if (userId) {
    const key = 'user-' + userId
    const tmp = await localforage.getItem(key) || {}
    localforage.setItem(key, _.set(tmp, `global.${path}`, data))
  }
}

export async function getUserData (path, defaultValue = null) {
  const userId = window.sessionStorage.getItem('user_id')
  if (userId) {
    const key = 'user-' + userId
    const tmp = await localforage.getItem(key) || {}
    return _.get(tmp, `global.${path}`, defaultValue)
  }
  return defaultValue
}

export async function setRootData (path, data) {
  const key = 'user-root'
  const tmp = await localforage.getItem(key) || {}
  localforage.setItem(key, _.set(tmp, `global.${path}`, data))
}

export async function getRootData (path, defaultValue = null) {
  const key = 'user-root'
  const tmp = await localforage.getItem(key) || {}
  return _.get(tmp, `global.${path}`, defaultValue)
}
